import React , { useState, useEffect }  from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import DashboardTitle from "./DashboardTitle";
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import constants from "../../services/constants";
import { getUserBussinessListFormData,
    getUserEventsListFormData,
    getUserJobsListFormData,
    getJobsListIdFormData,
    getUserOffersListFormData 
} from "../../services/routes.services";
import Modal from 'react-bootstrap/Modal'
import { IoClose } from "react-icons/io5";
import DashBoardOffer from "./DashboardOffer";

const DashBoard =()=>{
    const [businessData, setBusinessData] = useState([]);
    const [jobData, setJobData] = useState([]);
    const [eventData, setEventData] = useState([]);
    const [offerData, setOfferData] = useState([]);
    const { token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [showBusiness , setShowBusiness ]=  useState(false);
    const [showJobData , setShowJobData ]=  useState(false);
    const [userJobsData , setUserJobsData ] =  useState([]);
    const [skillsArray, setSkillsArray] = useState([]);
    const [userBusinessData , setUserBusinessData ] =  useState([]);

    const handleBusinessDataShow = (businessList) => {
        setShowBusiness(true);
        setUserBusinessData(businessList);
    }
    const handleClose = ()=>{
        setShowBusiness(false)
        setShowJobData(false)
        setUserJobsData([])
    }
    const handlejobDataShow = (jobId) => {
        setShowJobData(true);
        getJobsListIdFormData(jobId)
        .then((res) => {
            setUserJobsData(res.data);
            setSkillsArray(res.data.job.skills);
        })
        .catch((error) => {
            console.log(error);
        });
    }
    const handleEditBusinessData=(businessList)=>{
        navigate("/business-directory-create", { state: { Busnisslist: businessList } });
    }
    const handleEditJobsData=(jobList)=>{
        navigate("/myjobs", { state: { jobDetails: jobList } });
    }
    useEffect(() => {
            getUserBussinessListFormData(token)
            .then((res) => {
                setBusinessData(res.data.business);
            })
            .catch((error) => {
                console.log(error);
            });
            getUserEventsListFormData(token)
            .then((res) => {
                setEventData(res.data.events);
            })
            .catch((error) => {
                console.log(error);
            });
            getUserJobsListFormData(token)
            .then((res) => {
                setJobData(res.data.job);
            })
            .catch((error) => {
                console.log(error);
            });
               
            getUserOffersListFormData(token)
            .then((res) => {
                setOfferData(res.data.offers);
            })
            .catch((error) => {
                console.log(error);
            });
           
            
    }, []);
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };
      
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
        return formattedDate;
    };
    const handleEditBusinessPage=(Busnisslist)=>{
        navigate("/business-directory-create", { state: { Busnisslist: Busnisslist } });
    }
    return(
        <div className={'containerStyla  ' + Style.Dashboardscreen}>
<Container>
<DashboardTitle title="Dashboard" membertype="Non Member" />
          <Row>
            <Col>
                <div className={Style.dashboardPost}>
                    <div className={Style.postBox}>
                        <div className={Style.brownBg}>
                            <p>Event Passes</p>
                            <h6>{eventData.length ? eventData.length : '0' }</h6>
                        </div>
                        <Link to="/myevent">View Details</Link>
                    </div>
                    <div className={Style.postBox}>
                        <div className={Style.brownBg}>
                            <p>Business Listings</p>
                            <h6>{businessData.length ? businessData.length : '0' }</h6>
                        </div>
                        <Link to="/mybusinessdirectory">View Details</Link>
                    </div>
                    <div className={Style.postBox}>
                        <div className={Style.brownBg}>
                            <p>Job Listings</p>
                            <h6>{jobData.length ? jobData.length : '0' }</h6>
                        </div>
                        <Link to="/job-listing">View Details</Link>
                    </div>
                    <div className={Style.postBox}>
                        <div className={Style.brownBg}>
                            <p>Offers Posted</p>
                            <h6>{offerData.length ? offerData.length : '0' }</h6>
                        </div>
                        <Link to="/myoffer">View Details</Link>
                    </div>
                </div>
            </Col>
        </Row>
        <Row>
            <Col lg={6} className={Style.halfWidth}>
                <div className={Style.eventPost + ' ' + Style.LeftRow}>
                    <h4 className={Style.dashTitle}>Registered Events</h4>
                    <div className={Style.eventsRow}>
                        {eventData && eventData.length > 0 ?(
                            <>
                            {eventData.slice(0, 2).map((eventList)=>{
                                return(
                                    <div className={Style.listCol} key={eventList._id}>
                                        <figure>
                                            <img src={constants.IMAGE_BASE_URL+"/event/"+eventList.image} alt=""/>
                                        </figure>
                                        <div className={Style.listDetail}>
                                          {eventList.subTitle !=="null" &&  <span>{eventList.subTitle}</span>}
                                           {eventList.title !=="null" && <h4>{eventList.title}</h4>}
                                            <div className={Style.listOption}>
                                                <Link to= {eventList.externalUrl ==="null"?(`/event-detail/${eventList.eventSlug}`):eventList.externalUr}
                                                 onClick={smoothScroll}>View Details</Link>
                                                
                                                {/* <p>{formatDate(eventList.createdAt)}</p> */}
                                            </div>
                                        </div>
                                    </div>           
                                )
                            })}
                            <div className={Style.viewBtn}>
                                <Link to="/myevent">View More</Link>
                            </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </Col>
            <Col lg={6} className={Style.halfWidth}>
                <div className={Style.businessList + ' ' + Style.RightRow}>
                    <h4 className={Style.dashTitle}>Business Listings</h4>
                    <Link to="/business-directory-create" className={Style.greenBtn} onClick={smoothScroll}>Add Listing</Link>
                    <div className={Style.businessRow}>
                        {businessData && businessData.length > 0 ? (
                            <>
                            {businessData.slice(0, 2).map((businessList)=>{
                                return(
                                    <div className={Style.listCol} key={businessList._id}>
                                        <figure>
                                            <img src={constants.IMAGE_BASE_URL+"/business/"+businessList.image} alt=""/>
                                        </figure>
                                        <div className={Style.listDetail}>
                                            <h4>{businessList.name}</h4>
                                            <p>{businessList.username}</p>
                                            <span>{businessList.designation}</span>
                                            <div className={Style.listOption}>
                                                <a  href="#" onClick={(e) => {e.preventDefault();handleEditBusinessData(businessList)}}>Edit</a>
                                                <a  href="#" onClick={(e) => {e.preventDefault();handleBusinessDataShow(businessList)}}>More Detail</a>
                                                {/* <p>{formatDate(businessList.createdAt)}</p> */}
                                            </div>
                                        </div>
                                        {showBusiness &&
                                            <div className={Style.popOverlay}>
                                                <div className={Style.discountPopup}>
                                                    <button type="button" className={Style.closePopup} onClick={handleClose}><IoClose /></button>
                                                    <div className={Style.discountDetails}>
                                                        <div className={Style.companyLogo}>
                                                                <img src={constants.IMAGE_BASE_URL+'business/'+userBusinessData.image} alt=""/>
                                                        </div>
                                                        <div className={Style.offerHead}>
                                                            <h2>{userBusinessData.name}
                                                            </h2>
                                                            <p>{userBusinessData.categoryId && userBusinessData.categoryId.name}</p>
                                                        </div>
                                                        <div className={Style.offerDetails}>
                                                            <table role="none">
                                                                <tbody><tr>
                                                                    <td className={Style.left}>Business Name</td>
                                                                    <td className={Style.right}>{userBusinessData.name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className={Style.left}>Category</td>
                                                                    <td className={Style.right}>{userBusinessData.categoryId && userBusinessData.categoryId.name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className={Style.left}>Description</td>
                                                                    <td className={Style.right}>{userBusinessData.description}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className={Style.left}>Business Contact No.</td>
                                                                    <td className={Style.right}>{userBusinessData.phone}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className={Style.left}>CITY</td>
                                                                    <td className={Style.right}>{userBusinessData.city && userBusinessData.city.name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className={Style.left}>Country</td>
                                                                    <td className={Style.right}>{userBusinessData.country && userBusinessData.country.name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className={Style.left}>Alumni Member name</td>
                                                                    <td className={Style.right}>{userBusinessData.username}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className={Style.left}>Designation</td>
                                                                    <td className={Style.right}>{userBusinessData.designation}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className={Style.left}>Batch</td>
                                                                    <td className={Style.right}>2000</td>
                                                                </tr>
                                                            </tbody></table>
                                                        </div>
                                                        <a  href="#" onClick={(e) => {e.preventDefault();handleEditBusinessPage(userBusinessData)}} className={Style.greenBtn}>Edit</a>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                            <div className={Style.viewBtn}>
                                <Link to="/mybusinessdirectory" onClick={smoothScroll}>View More</Link>
                            </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </Col>
            <Col lg={6} className={Style.halfWidth}>
                <div className={Style.eventPost + ' ' + Style.LeftRow}>
                    <h4 className={Style.dashTitle}>Job Listings</h4>
                    <Link to="/myjobs" className={Style.greenBtn} onClick={smoothScroll}>Add Job</Link>
                    <div className={Style.jobsRow}>
                        {jobData && jobData.length > 0 ?(
                            <>
                            {jobData.slice(0, 2).map((jobList)=>{
                                return(
                                    <div className={Style.listCol} key={jobList._id}>
                                        <figure>
                                            
                                             <img src={constants.IMAGE_BASE_URL+'business/'+jobList.image} alt={jobList._id} />
                                        </figure>
                                        <div className={Style.listDetail}>
                                            <span>{jobList.jobRole}</span>
                                            <h4>{jobList.jobType}</h4>
                                            <p>{jobList.company}</p>
                                            <div className={Style.listOption}>
                                                <a  href="#" onClick={(e) => {e.preventDefault();handleEditJobsData(jobList)}}>Edit</a>
                                                <a  href="#" onClick={(e) => {e.preventDefault();handlejobDataShow(jobList._id)}}>More Detail</a>
                                            </div>
                                        </div>
                                        <Modal show={showJobData} onHide={handleClose}>
                                            <Modal.Body>
                                                {userJobsData.length!==0 &&
                                                <div className={Style.discountPopup}>
                                                    {console.log(userJobsData,"userJobsData")}
                                                    <span className={Style.closePopup} onClick={handleClose}>X</span>
                                                    
                                                    
                                                            <div className={Style.discountDetails}>
                                                            <div className={Style.companyLogo}>
                                                                    {/* <img src="https://mayoapi.mayoalumni.in/upload/businessdirectory/download - Copy (2).jpg" /> */}
                                                                  {userJobsData.job[0].image !==undefined &&  <img src={constants.IMAGE_BASE_URL+'business/'+userJobsData.job[0].image} alt={userJobsData.job[0]._id} />}
                                                            </div>
                                                            <div className={Style.offerHead}>
                                                               {userJobsData.jobtype.map(jobdata=>{
                                                                if(userJobsData.job[0].jobType===jobdata._id){
                                                                return(
                                                                    <h2 key={jobdata._id}>
                                                                    {jobdata.name}
                                                                </h2>
                                                                )}
                                                               }) }
                                                                <p>
                                                                {userJobsData.job[0].jobRole}
                                                                </p>
                                                            </div>
                                                           
                                                                <div className={Style.offerDetails}>
                                                              
                                                               <table role="none">
                                                               <tbody><tr>
                                                                   <td className={Style.left}>Business Name</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].company}</td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>Category</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].category}</td>
                                                               </tr>
                                                               
                                                               <tr>
                                                                   <td className={Style.left}>Business Contact No.</td>
                                                                   <td className={Style.right}> {userJobsData.job[0].phone}</td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>CITY</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].city} </td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>Experience</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].experience}</td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>Website</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].website}</td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>Skills</td>
                                                                   <td className={Style.right}>
                                                                              {userJobsData.job[0].skills}
                                                                           </td>
                                                               </tr>
                       
                                                               <tr>
                                                                   <td className={Style.left}>Description</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].description}</td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>Posted By Name</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].username}</td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>Designation</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].designation}</td>
                                                               </tr>
                                                               <tr>
                                                                   <td className={Style.left}>Batch</td>
                                                                   <td className={Style.right}>{userJobsData.job[0].batch}</td>
                                                               </tr>
                                                           </tbody></table>
                                                                
                                                            </div>
                                                               
                                                        
                                                            {/* <a  href="#" onClick={(e) => {e.preventDefault();handleEditPage(userJobsData.job[0])}} className={Style.greenBtn}>Edit</a> */}
                                                            </div>
                                                   
                                                </div>
                            }
                                            </Modal.Body>
                                        </Modal>
                                    </div>
                                )
                            })}
                            <div className={Style.viewBtn}>
                                <Link to="/job-listing" onClick={smoothScroll}>View More</Link>
                            </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </Col>
            <Col lg={6} className={Style.halfWidth}>
           
                    <DashBoardOffer offerData={offerData}/>
               
            </Col>
        </Row>
    </Container>
    </div>
    )
}
export default DashBoard;